import { CircularProgress, IconButton } from '@mui/material'
import React from 'react'

import { UIcon } from '@src/components'

import styles from './styles.module.scss'
import { UIconButtonProps } from './type'

const mapLoadingIconSize: Record<
  NonNullable<UIconButtonProps['size']>,
  number
> = {
  large: 22,
  medium: 14,
  small: 10,
}

export const UIconButton = ({
  isLoading,
  variant = 'outlined',
  iconProps,
  color,
  size = 'large',
  ...props
}: UIconButtonProps) => {
  return (
    <IconButton
      className={styles[variant]}
      color={color}
      size={size}
      {...props}
    >
      {isLoading ? (
        <CircularProgress
          color="inherit"
          size={size && mapLoadingIconSize[size]}
        />
      ) : (
        <UIcon fontSize={size} {...iconProps} />
      )}
    </IconButton>
  )
}
